export { default as DetailSection } from './DetailSection';
export { default as MasterSection } from './MasterSection';
